module.exports = __webpack_public_path__ + "img/me.38a3858e.png";